import type { TableDefinition } from '../engine/tables/definition';
import type { CommunityTableDetail } from './api';

export interface TrackingTarget {
  tableId: string;
  versionId: string | null;
}

export function trackingTarget(
  table: TableDefinition,
  remoteTable: Pick<CommunityTableDetail, 'id' | 'versionId'> | null,
): TrackingTarget | null {
  if (remoteTable) return { tableId: remoteTable.id, versionId: remoteTable.versionId };
  if (table.provenance?.isOfficial && table.provenance?.isPublished) {
    return { tableId: table.id, versionId: null };
  }
  return null;
}
